export interface Coalition {}
